import React, { useEffect, useState, useRef } from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useEditor,
} from "@smartfire/gutenberg-react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.scss";
import "./style.scss";
import "./editor.scss";
import CapsaTitle from "../CapsaTitle/block.js";
import {
  Button,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid/Grid";
import { MediaUpload, PlainText } from "@wordpress/editor";
import { ReactComponent as Arrow } from "./fleche-blanc.svg";
import { ReactComponent as Ligne } from "./ligne.svg";

function Block() {
  const { isEditing } = useEditor();
  const sliderRef = useRef(null);
  const [articles, setArticles] = useState([]);
  const [windowWidth, setWindowWidth] = useState();
  const [isSmallSlider, setIsSmallSlider] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [image1Url, setImage1Url] = useSmartProp("image1Url");
  const [title1, setTitle1] = useSmartProp("title1");
  const [description1, setDescription1] = useSmartProp("description1");
  const [url1, setUrl1] = useSmartProp("url1");
  const [image2Url, setImage2Url] = useSmartProp("image2Url");
  const [title2, setTitle2] = useSmartProp("title2");
  const [description2, setDescription2] = useSmartProp("description2");
  const [url2, setUrl2] = useSmartProp("url2");
  const [image3Url, setImage3Url] = useSmartProp("image3Url");
  const [title3, setTitle3] = useSmartProp("title3");
  const [description3, setDescription3] = useSmartProp("description3");
  const [url3, setUrl3] = useSmartProp("url3");

  const nl2br = (str) => {
    if (typeof str === "undefined" || str === null) {
      return "";
    }
    var breakTag = "<br />";
    return (str + "").replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      "$1" + breakTag + "$2"
    );
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, [windowWidth]);

  useEffect(() => {
    let articlesArray = [];
    if (image1Url) {
      articlesArray.push({
        title: nl2br(title1),
        description: nl2br(description1),
        url: url1,
        resource: { url: image1Url },
      });
    }

    if (image2Url) {
      articlesArray.push({
        title: nl2br(title2),
        description: nl2br(description2),
        url: url2,
        resource: { url: image2Url },
      });
    }

    if (image3Url) {
      articlesArray.push({
        title: nl2br(title3),
        description: nl2br(description3),
        url: url3,
        resource: { url: image3Url },
      });
    }

    setArticles(articlesArray);
  }, [
    image1Url,
    image2Url,
    image3Url,
    title1,
    description1,
    url1,
    title2,
    description2,
    url2,
    title3,
    description3,
    url3,
  ]);

  useEffect(() => {
    if (windowWidth > 1024 && !title1 && !title2 && !title3) {
      setIsSmallSlider(true);
    } else {
      setIsSmallSlider(false);
    }
  }, [setIsSmallSlider, windowWidth, title1, title2, title3]);

  const settings = {
    dots: windowWidth <= 767 ? false : true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    centerPadding: isSmallSlider ? "5px" : "0px",
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 6000,
    fade: false,
    appendDots: (dots) => (
      <div>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    adaptiveHeight: true,
    variableWidth: isSmallSlider && articles.length > 1,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  if (isEditing) {
    const getImageButton = (openEvent) => {
      if (image1Url) {
        return (
          <div>
            <Button
              onClick={() => setImage1Url("")}
              className="button button-large"
            >
              {" "}
              Supprimer l'image{" "}
            </Button>
            <div
              className="image"
              style={{ backgroundImage: "url(" + image1Url + ")" }}
              onClick={openEvent}
            />
          </div>
        );
      } else {
        return (
          <div className="image">
            <div className="button-container">
              <Button onClick={openEvent} className="button button-large">
                {" "}
                Sélectionner une image{" "}
              </Button>
            </div>
          </div>
        );
      }
    };

    const getImage2Button = (openEvent) => {
      if (image2Url) {
        return (
          <div>
            <Button
              onClick={() => setImage2Url("")}
              className="button button-large"
            >
              {" "}
              Supprimer l'image{" "}
            </Button>
            <div
              className="image"
              style={{ backgroundImage: "url(" + image2Url + ")" }}
              onClick={openEvent}
            />
          </div>
        );
      } else {
        return (
          <div className="image">
            <div className="button-container">
              <Button onClick={openEvent} className="button button-large">
                {" "}
                Sélectionner une image{" "}
              </Button>
            </div>
          </div>
        );
      }
    };

    const getImage3Button = (openEvent) => {
      if (image3Url) {
        return (
          <div>
            <Button
              onClick={() => setImage3Url("")}
              className="button button-large"
            >
              {" "}
              Supprimer l'image{" "}
            </Button>
            <div
              className="image"
              style={{ backgroundImage: "url(" + image3Url + ")" }}
              onClick={openEvent}
            />
          </div>
        );
      } else {
        return (
          <div className="image">
            <div className="button-container">
              <Button onClick={openEvent} className="button button-large">
                {" "}
                Sélectionner une image{" "}
              </Button>
            </div>
          </div>
        );
      }
    };
    return (
      <div className="admin-head-slider">
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Carousel Haut de page
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container spacing={24}>
              <Grid item xs={5}>
                <MediaUpload
                  onSelect={(media) => {
                    setImage1Url(media.url);
                  }}
                  type="image"
                  render={({ open }) => getImageButton(open)}
                />
              </Grid>
              <Grid item xs={7}>
                <PlainText
                  onChange={(content) => setTitle1(content)}
                  value={title1}
                  placeholder="Titre Diapo 1"
                  className="heading title"
                />
                <PlainText
                  onChange={(content) => setDescription1(content)}
                  value={description1}
                  placeholder="Description Diapo 1"
                  className="description"
                />
                <PlainText
                  onChange={(content) => setUrl1(content)}
                  value={url1}
                  placeholder="URL Diapo 1"
                  className="link"
                />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Grid container spacing={24}>
              <Grid item xs={5}>
                <MediaUpload
                  onSelect={(media) => {
                    setImage2Url(media.url);
                  }}
                  type="image"
                  render={({ open }) => getImage2Button(open)}
                />
              </Grid>
              <Grid item xs={7}>
                <PlainText
                  onChange={(content) => setTitle2(content)}
                  value={title2}
                  placeholder="Titre Diapo 2"
                  className="heading title"
                />
                <PlainText
                  onChange={(content) => setDescription2(content)}
                  value={description2}
                  placeholder="Description Diapo 2"
                  className="description"
                />
                <PlainText
                  onChange={(content) => setUrl2(content)}
                  value={url2}
                  placeholder="URL Diapo 2"
                  className="link"
                />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <Grid container spacing={24}>
              <Grid item xs={5}>
                <MediaUpload
                  onSelect={(media) => {
                    setImage3Url(media.url);
                  }}
                  type="image"
                  render={({ open }) => getImage3Button(open)}
                />
              </Grid>
              <Grid item xs={7}>
                <PlainText
                  onChange={(content) => setTitle3(content)}
                  value={title3}
                  placeholder="Titre Diapo 3"
                  className="heading title"
                />
                <PlainText
                  onChange={(content) => setDescription3(content)}
                  value={description3}
                  placeholder="Description Diapo 3"
                  className="description"
                />
                <PlainText
                  onChange={(content) => setUrl3(content)}
                  value={url3}
                  placeholder="URL Diapo 3"
                  className="link"
                />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  } else {
    return (
      <>
        <div className="content-container">
          <div className="head-slider-block">
            {isSmallSlider && articles.length > 1 && (
              <div className={"arrow left"}>
                <div
                  className={"prev"}
                  onClick={() => sliderRef.current.slickPrev()}
                ></div>
              </div>
            )}
            <Slider
              ref={sliderRef}
              {...settings}
              className={
                isSmallSlider && articles.length === 1 && "uniqueSlide"
              }
            >
              {articles.map((slide, index) => (
                <div sliderRef={sliderRef} key={index} className="slideElement">
                  <img
                    className={"image slider imageSlider "}
                    alt={""}
                    style={{
                      width:
                        isSmallSlider &&
                        articles.length > 1 &&
                        (windowWidth <= 1440 ? "830px" : "940px"),
                      height: isSmallSlider && articles.length > 1 && "500px",
                      margin: isSmallSlider && "0 5px",
                    }}
                    src={slide.resource.url}
                  />
                </div>
              ))}
            </Slider>
            {articles.map((element, index) => (
              <div
                className={`${"containerSlide"} ${
                  articles.length === 1 && "oneSlide"
                } ${index !== currentSlide && "containerSliderDisable"} ${
                  element.title === "" &&
                  element.description === "" &&
                  "no_line"
                }`}
              >
                <div
                  className={
                    "content " + (element.description ? "has-description" : "")
                  }
                >
                  <div className="description">
                    {element.title !== "" && (
                      <CapsaTitle
                        type="h1"
                        title={element.title}
                        text="white"
                        bg="blue"
                        position="left"
                      />
                    )}
                    <div
                      className={
                        "contentContainer " + (element.url ? "" : "noButton")
                      }
                    >
                      <div
                        className="content"
                        dangerouslySetInnerHTML={{
                          __html: element.description,
                        }}
                      />
                    </div>
                    {element.description && (
                      <div className="btn">
                        {element.url ? (
                          <a href={element.url}>
                            <Arrow />{" "}
                          </a>
                        ) : null}
                        {articles.length > 1 ? (
                          <div className="dots mobile">
                            {articles.map((elt, dotIndex) => (
                              <div
                                className={dotIndex === index && "active"}
                                onClick={() =>
                                  sliderRef.current.slickGoTo(dotIndex)
                                }
                              ></div>
                            ))}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
                {element.title && element.description && <Ligne />}
              </div>
            ))}
            {isSmallSlider && articles.length > 1 && (
              <div className={"arrow right"}>
                <div
                  className={"next"}
                  onClick={() => sliderRef.current.slickNext()}
                ></div>
              </div>
            )}
          </div>
          <img className="hiddenImage" alt={""} src={image1Url} />
          <img className="hiddenImage" alt={""} src={image2Url} />
          <img className="hiddenImage" alt={""} src={image3Url} />
        </div>
      </>
    );
  }
}

export default defineBlock({
  Block,
  smartProps: {
    image1Url: smartProps.string.withDefault(),
    title1: smartProps.string.withDefault(),
    description1: smartProps.string.withDefault(),
    url1: smartProps.string.withDefault(),
    image2Url: smartProps.string.withDefault(),
    title2: smartProps.string.withDefault(),
    description2: smartProps.string.withDefault(),
    url2: smartProps.string.withDefault(),
    image3Url: smartProps.string.withDefault(),
    title3: smartProps.string.withDefault(),
    description3: smartProps.string.withDefault(),
    url3: smartProps.string.withDefault(),
  },
  setup: {
    title: "Header slider",
  },
});
